import { FETCH_ISL_REWARDS_META, FETCHING_ISL_REWARDS_META  } from "../actionTypes";

export const fetchingIslRewardsMeta = payload => ({
    type: FETCHING_ISL_REWARDS_META,
    payload
});

export const fetchIslRewardsMeta = payload => ({
    type: FETCH_ISL_REWARDS_META,
    payload
});